<nz-form-item class="col-span">
  <div class="form-table">
    <div class="table-header">
      <h2 class="title s-18">Learning guideline</h2>
      <button
        nz-button
        nzType="primary"
        type="button"
        (click)="addRow()"
        [disabled]="!canAddNewRow()">
        Add Row
      </button>
    </div>

    <nz-table
      [nzData]="listOfData"
      [nzFrontPagination]="false"
      [nzShowPagination]="false">
      <thead>
        <tr>
          <th nzWidth="20%">Sequence</th>
          <th nzWidth="70%">Guideline</th>
          <th nzWidth="100px"></th>
        </tr>
      </thead>
      <tbody cdkDropList (cdkDropListDropped)="drop($event)">
        @for (data of listOfData; track data.sequence; let i = $index) {
          <tr cdkDrag>
            <td nzWidth="20%" class="drag-point">
              <button nz-button nzType="text">
                <svg-icon src="/assets/icon/icon-drag.svg" class="icon s-20">
                </svg-icon>
                {{ data.sequence }}
              </button>
            </td>
            <td nzWidth="70%">
              <textarea
                [value]="data.guideline"
                (input)="updateGuideline(i, $event)"
                rows="2"
                nz-input
                [nzStatus]="isInvalid(i) ? 'error' : ''"
                [nzAutosize]="{ minRows: 2, maxRows: 6 }"
                placeholder="Enter your text">
              </textarea>
              @if (isInvalid(i)) {
                <div class="ant-form-item-explain-error">
                  {{ getError(i) }}
                </div>
              }
            </td>
            <td nzWidth="100px">
              <div class="action-btn-wrapper">
                <button
                  nz-button
                  type="button"
                  nzType="text"
                  (click)="removeRow(i)">
                  <svg-icon src="/assets/icon/icon-trash.svg" class="icon s-20">
                  </svg-icon>
                </button>
              </div>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</nz-form-item>
